/**
 * How Launch writes an amount and a moment, in one place, so the price, the accepted checkout and
 * a payment problem's date are all said alike.
 */

/** An amount in its currency, from whole cents. */
export const priceLabel = (quote: { currency: string; total_cents: number }): string =>
  new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: quote.currency,
  }).format(quote.total_cents / 100);

/** A moment beside the price — when it holds until, or when it was worked out — as a date and time. */
export const priceTimeLabel = (iso: string): string =>
  new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(
    new Date(iso),
  );
